import { useEffect, useState } from 'react'
import { changeCoopState } from '../../../../stores/GlobalState'
import { observer } from 'mobx-react'

import { ReactComponent as ArrowLeft } from '../../../../assets/arrow-left.svg'
import classNames from 'classnames'
import { SolutionTab } from '../Solutions'

import { ReactComponent as Linkedin } from '../../../../assets/socials/akar-icons_linkedin-fill.svg'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
const Team = observer(() => {
  const content = ContentState
  const [solution, setSolution] = useState<any>('')

  const [width, setWidth] = useState(window.innerWidth)

  const tabs = Array.from(
    new Set(content?.about?.team?.list?.map((t: any) => t.country)),
  )

  useEffect(() => {
    setWidth(window.innerWidth)
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  useEffect(() => {
    if (content.about?.team) {
      setSolution(tabs[0])
    }
  }, [content.about?.team])
  if (!content.about?.team) return <></>

  const openlinkbuton = () =>{
    window.location.href = "" + content?.about?.buttonCoop.link;
  }

  return (
    <section className="team" id="team">
      <div className="team__container">
        <div className="team__top">
          <div
            className="team__title"
            dangerouslySetInnerHTML={{
              __html: content?.about?.team?.title,
            }}
          ></div>
          <div
            className="team__text"
            dangerouslySetInnerHTML={{
              __html: content?.about?.team?.text,
            }}
          ></div>
        </div>
        {tabs?.length > 1 && (
          <div className="we-block__solutions-tabs">
            {tabs.map((s: any, i: number) => (
              <SolutionTab
                title={s}
                key={i}
                active={solution == s}
                setTab={(value) => setSolution(value)}
              />
            ))}
          </div>
        )}
        <div className="team__list">
          {content?.about?.team?.list
            ?.filter((t: any) => t.country == solution)
            ?.map((te: any, i: number) => (
              <div className="team__item" key={i}>
                <a
                  className={classNames(
                    'team__item-imgcont',
                    te.link && 'active',
                  )}
                  {...(te.link
                    ? {
                        href: te.link || '',
                        target: '_blank',
                      }
                    : {})}
                >
                  {te.link ? (
                    <div className="team__item-link">
                      <Linkedin />
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className={classNames('team__item-img')}>
                    {te.src && <img src={te.src} />}
                  </div>
                </a>

                <div className="team__item-title">{te.title}</div>
                <div className="team__item-position">{te.position}</div>
              </div>
            ))}
        </div>
        <div className="team__bottom">
          <div className="team__bottom-block">
            <div
              className="team__bottom-btn white button-active"
              onClick={() => {
                if (width <= 768) {
                  setTimeout(() => {
                    document
                      .querySelector('.team__bottom-btn')
                      ?.classList.toggle('button-active')
                  }, 300)

                  setTimeout(() => {
                    document
                      .querySelector('.team__bottom-btn')
                      ?.classList.add('button-active')
                  }, 310)
                }
                openlinkbuton();
                //changeCoopState()
              }}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: content.about.buttonCoop.title,
                }}
              ></span>
            </div>
          </div>
          <div className="team__bottom-block">
            <div
              className="team__bottom-arrow"
              onClick={() => {
                window.scrollTo(0, 0)
              }}
            >
              <ArrowLeft />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
})

export default Team
